import axios from "axios";

export const GET_NOTIFICATION_MESSAGES = "GET_NOTIFICATION_MESSAGES";
export const GET_NOTIFICATION_HISTORY = "GET_NOTIFICATION_HISTORY";
export const GET_NOTIFICATION_CATEGORIES = "GET_NOTIFICATION_CATEGORIES";
export const CREATE_NOTIFICATION_MESSAGE = "CREATE_NOTIFICATION_MESSAGE";
export const UPDATE_NOTIFICATION_MESSAGE = "UPDATE_NOTIFICATION_MESSAGE";
export const DELETE_NOTIFICATION_MESSAGE = "DELETE_NOTIFICATION_MESSAGE";
export const SEND_NOTIFICATION_EMAILS = "SEND_NOTIFICATION_EMAILS";

export const getNotificationMessages = (categoria) => (dispatch) => {
    const url = categoria ? "notificacion/byCategory" : "notificacion";
    const params = categoria ? { categoria } : undefined;

    dispatch({
        type: GET_NOTIFICATION_MESSAGES,
        payload: axios
            .get(url, { params })
            .then((response) => ({ data: response.data }))
            .catch((error) => Promise.reject(error)),
    });
};

export const getNotificationHistory = (categoria) => (dispatch) => {
    const params = categoria ? { categoria } : undefined;

    dispatch({
        type: GET_NOTIFICATION_HISTORY,
        payload: axios
            .get("notificacion/historial", { params })
            .then((response) => ({ data: response.data }))
            .catch((error) => Promise.reject(error)),
    });
};

export const getNotificationCategories = () => (dispatch) => {
    dispatch({
        type: GET_NOTIFICATION_CATEGORIES,
        payload: axios
            .get("notificacion/categorias")
            .then((response) => ({ data: response.data }))
            .catch((error) => Promise.reject(error)),
    });
};

export const createNotificationMessage = (message) => (dispatch) => {
    return dispatch({
        type: CREATE_NOTIFICATION_MESSAGE,
        payload: axios
            .post("notificacion", message)
            .then((response) => ({ data: response.data }))
            .catch((error) => Promise.reject(error)),
    });
};

export const updateNotificationMessage = (id, message) => (dispatch) => {
    return dispatch({
        type: UPDATE_NOTIFICATION_MESSAGE,
        payload: axios
            .put(`notificacion/${id}`, message)
            .then((response) => ({ data: response.data }))
            .catch((error) => Promise.reject(error)),
    });
};

export const deleteNotificationMessage = (id) => (dispatch) => {
    return dispatch({
        type: DELETE_NOTIFICATION_MESSAGE,
        payload: axios
            .delete(`notificacion/${id}`)
            .then(() => ({ id }))
            .catch((error) => Promise.reject(error)),
    });
};

export const sendNotificationEmails = (payload) => (dispatch) => {
    return dispatch({
        type: SEND_NOTIFICATION_EMAILS,
        payload: axios
            .post("notificacion/enviar", payload)
            .then((response) => ({ data: response.data }))
            .catch((error) => Promise.reject(error)),
    });
};
